/** zh-CN catalogue `tools` (W3-09; English: src/core/tools/tools.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'tools',
  locale: 'zh-CN',
  messages: {
    'distribute.nothing': '请选中要分布数值的音符或关键帧。',
    'distribute.badNumber': '起始值、结束值、序列和随机范围必须是数字。',
    'distribute.notNumeric': '这些关键帧存放的是颜色或文字；分布只适用于数值。',
    'distribute.lastKey': '已跳过 {count, plural, other {# 个末尾关键帧}}：缓动属于关键帧之后的区段。',
    'distribute.easeSkipped': '{count, plural, other {# 个区段}}保留了原来的缓动：那里不允许使用该缓动。',
    'distribute.clamped': '有 {count, plural, other {# 个值}}超出允许范围，已设为最接近的允许值。',
    'distribute.evalFailed': '第 {index} 项（共 {count} 项）没有得到可用的值。请检查起始值、结束值和序列。',
    'distribute.arriveAfterStay': '保留了 {count, plural, other {# 个到达值}}：钩定之后的到达值就是保持的值。',
    'distribute.skippedKeys': '有 {count, plural, other {# 个关键帧}}存放的是颜色或文字，未作更改。',
    'clone.nothing': '请先选中要克隆的区段（和音符）。',
    'clone.oneLine': '克隆一次只处理一条判定线的运动和音符。请选中同一条判定线上的项目。',
    'clone.noTargets': '请至少选择一条目标判定线，或新建判定线。',
    'clone.count': '请创建 1 到 {max} 条判定线。',
    'clone.skippedOverlap': '已跳过 {count, plural, other {# 份副本}}，因为目标在那里已有运动。',
    'clone.notesOnUiMover': '音符未复制到 {count, plural, other {# 条 UI 绑定线}}：Phira 不会在其上绘制音符。',
    'clone.notApplicable':
      '未使用{prop, select, moveX {X} moveY {Y} rotate {旋转} alpha {不透明度} other {属性}}递变：没有克隆任何{prop, select, moveX {X} moveY {Y} rotate {旋转} alpha {不透明度} other {此类}}区段。',
    'clone.newLayerFallback':
      '{count, plural, other {# 份副本}}替换了现有的运动：那里无法使用新层级（该属性没有层级，或四个层级都已使用）。',
    'clone.sourceRemoved': '已移除源运动（“保留源”已关闭）：它现在保持在起始值。',
    'clone.targetSkipped': '{count, plural, other {# 条目标判定线}}已不存在，已跳过。',
    'fill.needTwo': '请选中两个音符：填充开始处和结束处。',
    'fill.sameLine': '两个音符必须在同一条判定线上。',
    'fill.sameTime': '两个音符位于同一时间。请选择不同时间的音符。',
    'fill.badSpacing': '间距必须大于零，或数量至少为 1。',
    'fill.tooMany': '这样会创建超过 {max} 个音符。请使用更大的间距。',
    'fill.none': '以此间距，两个音符之间放不下任何音符。请使用更小的间距。',
    'fill.template': '新音符的默认设置不可用。请改用起始音符的属性。',
    'path.range': '路径的开始必须早于结束，且位于第 0 拍或之后。',
    'path.expr': '{axis, select, x {x(t)} y {y(t)} r {r(t)} other {路径}}表达式有错误。',
    'path.eval': '路径在第 {beat} 拍没有值（例如除以零）。请调整表达式。',
    'path.density': '每拍关键帧数必须是 1 到 {max} 之间的整数。',
    'path.tolerance': '拟合容差必须是大于 0 的数字。',
    'path.tooMany': '该路径每个轴需要超过 {max} 个关键帧。请减少每拍关键帧数或增大容差。',
    'path.overlap': '判定线在路径的时间范围内已在此层级上运动。请选择“替换”，或写入新层级。',
    'path.noFreeLayer': '此判定线的四个层级都已使用。请选择一个要替换的层级。',
    'path.layer': '路径已写入层级 {layer}。',
    'path.layerInvalid': '层级从 0 开始编号。',
    'path.fitted': '已用 {count} 个关键帧拟合，误差在 {tolerance} px 以内。',
    'flatten.notLayered': '只有位置、旋转、不透明度和流速有可合并的层级。',
    'flatten.oneLayer': '此属性只有一个层级：没有可合并的内容。',
    'flatten.tolerance': '容差必须是大于 0 的数字。',
    'flatten.exact': '已精确合并层级：运动没有变化。',
    'flatten.baked': '已合并层级。有 {count, plural, other {# 段}}无法精确合并，已变为短直线分段（最大差异 {error}）。',
    'flatten.tooMany': '合并需要超过 {max} 个关键帧。请使用更大的容差。',
    'flatten.partner': '此判定线的 X 和 Y 位置已关联，因此两者一起合并。',
    'fit.tolerance': '容差必须是大于 0 的数字。',
    'fit.nothing': '请选中要简化的数值区段。',
    'fit.done': '已将关键帧从 {before} 个简化为 {after} 个（最大差异 {error}）。',
    'fit.none': '在 {tolerance} 的容差内没有可合并的关键帧。',
    'stagger.nothing': '请选中要错开的音符或关键帧。',
    'stagger.zero': '错开步长不能为零。',
    'stagger.single': '错开需要位于两个或更多不同时间的项目。',
    'retime.collide': '关键帧会越过或落在相邻关键帧上。请使用更小的步长，或把相邻关键帧也选中。',
    'retime.beforeStart': '项目不能移到第 0 拍之前。',
    lineMissing: '此判定线已不存在。',
  },
};

export default catalog;
